import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getBoldedText from "@insite/client-framework/Common/Utilities/getPatternBolded";
import Zone from "@insite/client-framework/Components/Zone";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import {
    addSearchHistory,
    clearSearchHistory,
    getSearchHistory,
    SearchHistoryItem,
} from "@insite/client-framework/Services/AutocompleteService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getAutocompleteModel from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import searchProducts from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SearchProducts";
import setProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { getProductSelector } from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorSelectors";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { selectProduct } from "@insite/client-framework/Store/Context/ContextActionCreators";
import {
    getCountriesDataView,
    getCurrentCountries,
} from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";

import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import translate from "@insite/client-framework/Translate";
import { ProductAutocompleteItemModel, StateModel } from "@insite/client-framework/Types/ApiModels";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import SearchHistory from "@insite/content-library/Widgets/Header/SearchHistory";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconPresentationProps } from "@insite/mobius/Icon";
import Clock from "@insite/mobius/Icons/Clock";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextArea, { TextAreaPresentationProps } from "@insite/mobius/TextArea/TextArea";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { formatPhoneNumber } from "@tCentro/Common/Utilities/formatPhoneNumber";
import createInquiryLineCardForm from "@tCentro/Handlers/CENInquiryLineCardFormHandler";
import ArrowRightIcon from "@tCentro/Icons/ArrowRightIcon";
import RightArrowIcon from "@tCentro/Icons/RightArrowIcon";
import SearchIcon from "@tCentro/Icons/SearchIcon";
import Popover from "@tCentro/MobiusOverrides/Popover";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { typography } from "@tCentro/theme/styleguide";
import debounce from "lodash/debounce";
import React, { ChangeEvent, RefObject, useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    tryourcatalogtypes = "tryourcatalogtypes",
    categoryName = "categoryName",
    categoryLink = "categoryLink",
    bannerImage = "bannerImage",
}

interface TryOurCatalogModel {
    fields: {
        categoryName: string;
        categoryLink: LinkFieldValue;
        bannerImage: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.tryourcatalogtypes]: TryOurCatalogModel[];
        [fields.bannerImage]: string;
    };
}
const mapStateToProps = (state: ApplicationState) => ({
    countries: getCurrentCountries(state),
    countriesDataView: getCountriesDataView(state, loadCurrentCountriesParameter).isLoading,
    searchResults: getProductSelector(state),
});

const mapDispatchToProps = {
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: RefObject<ReCAPTCHA> }, boolean>(
        validateReCaptcha,
    ),
    loadCurrentCountries,
    createInquiryLineCardForm,
    selectProduct,
    searchProducts,
    setProduct,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface CENTryOurNewCatalogStyles {
    container?: GridContainerProps;
    successModal?: InjectableCss;
    modalContainer?: GridContainerProps;
    mainContainer: InjectableCss;
    inputStyles?: TextFieldProps;
    submitButton?: InjectableCss;
    textAreaStyles?: TextAreaPresentationProps;
    productWrapper?: InjectableCss;
    searchInput?: TextFieldPresentationProps;
    header?: TypographyProps;
    productImage?: InjectableCss;
    productInfo?: InjectableCss;
    searchHistory?: InjectableCss;
    productMainWrapper?: InjectableCss;
    productContainer?: InjectableCss;
    mainWrapper?: InjectableCss;
    rowWrapper?: InjectableCss;
    getProduct?: InjectableCss;
    recentsearchWrapper?: InjectableCss;
    icon?: IconPresentationProps;
    searchModal?: InjectableCss;
    hoverMainWrapper?: InjectableCss;
    rightArrow?: InjectableCss;
    getSearchHeader?: InjectableCss;
    productInfoSearch?: InjectableCss;
    searchDiv?: InjectableCss;
    headingContainer?: InjectableCss;
}

export const cenTryOurNewCatalogStyles: CENTryOurNewCatalogStyles = {
    searchDiv: {
        css: css`
            margin-top: 24px;
        `,
    },
    headingContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    successModal: {
        css: css`
            position: relative;
            // bottom: 106px; /* Adjust this to control vertical position */
            max-width: 100%;
            width: 100%;
            max-height: 60%;
            height: auto;
            background-color: #fff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            padding: 20px;
            z-index: 1000;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            border-radius: 12px;
            .searchHeading {
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;
                margin-bottom: 16px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css`
                        /* padding-left: 0px; */
                        border: none;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    searchModal: {
        css: css`
            // position: absolute;

            // right: 100px;
            max-width: 100%;
            width: 100%;
            max-height: 60%;
            height: auto;
            background-color: #fff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            padding: 20px;
            z-index: 1000;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            border-radius: 12px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        position: relative;
                        max-width: 100%;
                        width: 100%;
                        right: 0px !important;
                    `,
                    css`
                        /* padding-left: 0px; */
                        border: none;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    recentsearchWrapper: {
        css: css`
            /* max-width: 1000px; */
            width: 70%;
            border-right: 1px solid ${COLORS.border.base};
            .searchHeading {
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css``,
                        css`
                            margin-top: 20px;
                            border-right: none;
                            width: 100%;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    icon: {
        src: Clock,
        size: 16,
        css: css`
            margin-right: 4px; // Add spacing between icon and text
            font-size: 16px;
            color: ${getColor("text.link")};
            svg {
                fill: ${getColor("text.link")};
                stroke: ${getColor("info.contrast")};
            }
        `,
    },
    inputStyles: {
        errorProps: {
            css: css`
                margin-left: 24px;
            `,
        },
        cssOverrides: {
            formField: css`
                padding-top: 24px;
                label {
                    font-size: ${TYPOGRAPHY.size.smaller};
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    line-height: 16px;
                    color: ${getProp("theme.typography.p.color")};
                    margin-left: 24px;
                    min-height: auto !important;
                }
            `,
            formInputWrapper: css`
                margin-top: 8px !important;
                input {
                    background: #f2f2f2 !important;
                    border-radius: 40px !important;
                    padding: 12px 24px !important;
                    min-height: 48px !important;
                    border: none !important;
                    &::placeholder {
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                    }
                }
            `,
        },
    },

    textAreaStyles: {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-size: 18px;
            font-weight: 400px;
            line-height: 24px;
        `,
    },
    header: {
        css: css`
            color: #262525;
            font-size: 32px !important;
            font-weight: 700 !important;
            line-height: 40px !important;
            margin-bottom: 0px;
        `,
    },
    mainContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            padding: 20px;
            border: 2px solid #f2f2f2;
            height: 100%;
            width: 100%;
            .bannerImg {
                margin-top: 20px;
                aspect-ratio: 126/23 !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px !important;
                        border: none;
                    `,
                    css`
                        padding-left: 0px;
                        border: none;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    searchInput: {
        sizeVariant: "default",
        iconProps: { src: SearchIcon },
        border: "underline",
        cssOverrides: {
            formField: css`
                width: 100%;
                margin-top: 0;
                position: relative;
                button {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                css`
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                css`
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                button > span {
                    color: ${getProp("theme.typography.p.color")};
                    top: 4px !important;

                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    top: 0 !important;
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                css`
                                    top: 0 !important;
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                css`
                                    top: 0 !important;
                                    padding: 0 !important;
                                    height: 32px !important;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }

                input {
                    color: ${COLORS.background.tag} !important;
                    border: 1px solid ${getColor("primary")} !important;
                    box-shadow: 0px 2px 8px 0px #26252529;
                    border-radius: 40px !important;
                    background: ${COLORS.background.grayShade} !important;
                    padding: 0 25px !important;
                    height: 48px;
                    font-size: 16px !important;
                    line-height: 24px;
                    &::placeholder {
                        color: ${COLORS.background.tag};
                        opacity: 1; /* Firefox */
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: ${COLORS.background.tag};
                    }

                    &::-ms-input-placeholder {
                        /* Microsoft Edge */
                        color: ${COLORS.background.tag};
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    height: 32px;
                                    padding-right: 45px !important;
                                `,
                                css`
                                    height: 32px;
                                `,
                                css`
                                    height: 32px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            `,
        },
    },
    productImage: {
        css: css`
            aspect-ratio: 1 / 1;
            max-width: 104px;
            max-height: 104px;
            width: 100%;
            height: auto;
            object-fit: contain;
            margin-right: 16px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            cursor: pointer;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            /* height: 70px; */
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    productWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            cursor: pointer;
            // align-items: center;
            // justify-content: space-between;
            padding: 10px;
            margin-bottom: 10px;
            width: 70%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        // width: 230px;
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 60%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    productInfo: {
        css: css`
            display: flex;
            flex-direction: column;

            .brandName {
                font-weight: 600; /* Example styling */
                font-size: 14px;
                line-height: 24px;
                color: ${getProp("theme.typography.p.color")};
                cursor: pointer;
            }
            .brandNameTitle {
                font-weight: 600; /* Example styling */
                font-size: 16px;
                line-height: 24px;
                color: ${getProp("theme.typography.p.color")};
            }
            .name {
                font-weight: 600; /* Example styling */
                font-size: 16px;
                line-height: 24px;
                color: ${getProp("theme.typography.p.color")};
                cursor: pointer;
            }
            .mpn {
                color: ${getProp("theme.typography.p.color")};
                font-weight: 600; /* Example styling */
                font-size: 14px;
                line-height: 16px;
                margin-top: 8px;
                span {
                    font-weight: 400;
                    b {
                        font-weight: 700;
                    }
                }
            }

            .categoryHeading {
                font-size: 14px;
                line-height: 16px;
                font-weight: 600;
                margin-top: 40px;
            }
            .searchDescription {
                font-weight: 400;
                font-size: 14px;
                line-height: 24px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                position: relative;
                                top: 30px;
                                width: 200px;
                            `,
                            css`
                                height: 32px;
                            `,
                            css`
                                height: 32px;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 500px;
                            width: 100%;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },

    productInfoSearch: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            .brandName {
                font-weight: 600; /* Example styling */
                font-size: 14px;
                line-height: 16px;
                color: ${getProp("theme.typography.p.color")};
            }

            .categoryWrapper {
                position: relative;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin-top: 0px;
                                order: 3;
                            `,
                            css``,
                            css``,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
            .categoryHeading {
                font-size: 14px;
                line-height: 16px;
                font-weight: 600;
                margin-top: 40px;
                margin-bottom: 16px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            /* margin-top: 70px; */
                            margin-top: 20px;
                        `,
                        css`
                            margin-top: 20px;
                        `,
                        css`
                            margin-top: 20px;
                        `,
                        null,
                        null,
                    ])}
            }
            .searchDescription {
                font-weight: 400;
                font-size: 14px;
                line-height: 24px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                position: relative;
                            `,
                            css`
                                /* height: 32px; */
                            `,
                            css`
                                /* height: 32px; */
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
            .categories {
                display: grid;
                grid-template-columns: repeat(3, auto);
                column-gap: 16px;
                row-gap: 8px;
                max-width: 616px;
                align-items: flex-start;
                justify-content: flex-start;
                padding-right: 10px;
                a {
                    max-width: 194px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css``,
                                css``,
                                css`
                                    max-width: 100%;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                span {
                    font-family: ${TYPOGRAPHY.fontFamily.title};
                    font-size: ${TYPOGRAPHY.size.tiny};
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                    line-height: 16px;
                    text-align: left;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            max-height: 400px;
                            align-items: flex-start;
                            grid-template-columns: repeat(1, 1fr);
                        `,
                        css`
                            align-items: flex-start;
                            grid-template-columns: repeat(1, 1fr);
                        `,
                        css`
                            align-items: flex-start;
                            grid-template-columns: repeat(2, auto);
                        `,
                        null,
                        null,
                    ])}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 500px;
                            width: 100%;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    searchHistory: {
        css: css`
            display: flex;
            align-items: center; // Align icon and text vertically
            margin-bottom: 5px;
        `,
    },
    productMainWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid ${COLORS.border.base};
            margin-right: 20px;
            .viewButton {
                margin: 30px 0px;
                font-size: 11px;
                padding: 8px 0px 8px 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-top: 0px;
                            margin-bottom: 10px;
                        `,
                        css`
                            margin-top: 0px;
                            margin-bottom: 10px;
                        `,
                        css``,
                        css``,
                        css``,
                    ])}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            .viewButton {
                                justify-content: center;
                                display: flex;
                            }
                            flex-direction: column;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    hoverMainWrapper: {
        css: css`
            display: flex;

            width: 100%;

            .recentSearch {
                /* max-width: 500px; */
                //  right: 100px;
                //  position: absolute;
                //  justify-content: flex-end;
                width: 30%;
                display: flex;
                flex-direction: column;
                /* width: 100%; */
                margin-left: 20px;
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;
                > span {
                    display: flex;
                    justify-content: space-between;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                position: relative;
                                left: 0px;
                                margin-left: 0px;
                            `,
                            css`
                                margin-left: 0px;
                            `,
                            css`
                                margin-left: 0px;
                                width: 100%;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}

                .searchList {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    color: ${COLORS.link.base};
                    font-weight: 600;
                    line-height: 16px;
                    font-size: 12px;

                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css``,
                                css``,
                                css`
                                    max-width: 100%;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                .clearAll {
                    color: ${getColor("text.link")};
                }
                .recentSearchHeader {
                    padding-bottom: 10px;

                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    justify-content: space-between;
                                    display: flex;
                                `,
                                css``,
                                css``,
                                null,
                                null,
                            ],
                            "max",
                        )}
                    a {
                        margin-left: 10px;
                        font-family: Poppins;
                        font-size: 12px;
                        font-weight: 600;
                        line-height: 16px;
                    }
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column-reverse;
                    `,
                    css`
                        flex-direction: column-reverse;
                    `,
                    css`
                        flex-direction: column-reverse;
                    `,
                    css`
                        flex-direction: row;
                    `,
                    css``,
                ])}
        `,
    },
    productContainer: {
        css: css`
            display: flex;
            flex-direction: row;
            position: absolute;
            top: 75px;
            right: 0px;
            width: 70vw;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        top: 59px;
                    `,
                    css`
                        width: 100%;
                        top: 59px;
                    `,
                    css`
                        width: 100%;
                        top: 59px;
                    `,
                    css``,
                    css`
                        width: 55vw;
                    `,
                ])}
        `,
    },
    mainWrapper: {
        css: css`
            display: flex;
            // flex-direction: row;
        `,
    },
    rowWrapper: {
        css: css`
            width: 100%; /* Adjust the width */
            max-height: 350px; /* Set a fixed height for the vertical scroll */
            overflow-y: auto; /* Enable vertical scrolling */

            box-sizing: border-box;
            ::-webkit-scrollbar {
                width: 8px;
            }
            ::-webkit-scrollbar-track {
                background: #f1f1f1;
            }
            ::-webkit-scrollbar-thumb {
                background-color: #888;
                border-radius: 10px;
                border: 2px solid transparent; /* To create padding around thumb */
            }
            ::-webkit-scrollbar-thumb:hover {
                background-color: #555;
            }
        `,
    },
    getProduct: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
            color: ${getProp("theme.typography.p.color")} !important;

            .getallProducts {
                padding: 0px 30px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px;
                            padding-right: 10px;
                        `,
                        css``,
                        css``,
                        css``,
                        css``,
                    ])}
                svg {
                    color: ${COLORS.link.base};
                }
            }
        `,
    },
    getSearchHeader: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;

            .getallProducts {
                padding: 0px 30px;
            }
            .searchHeading {
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;
            }
            .clearAll {
                padding-left: 30px;
                color: ${COLORS.link.base};
                text-align: right;
            }
            .recentSearchHeader {
                padding-bottom: 10px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: column;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = cenTryOurNewCatalogStyles;

const emailsRegexp = new RegExp(
    "^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$",
);
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

// const phoneRegex = /^\d{3}(-\d{3})?(-\d{4})?$/;
const phoneRegex = /^(\d{3}-){2}\d{4}$/;

const CENTryOurNewCatalog = ({
    id,
    fields,
    countries,
    countriesDataView,
    loadCurrentCountries,
    createInquiryLineCardForm,
    validateReCaptcha,
    searchProducts,
    searchResults,
    setProduct,
    history,
}: Props) => {
    const [product, setFilterProduct] = useState<ProductAutocompleteItemModel[]>([]);
    const [hover, setHover] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [searchHistory, setSearchHistory] = useState<SearchHistoryItem[]>([]);
    const [focusedSearchHistoryQuery, setFocusedSearchHistoryQuery] = useState<string | null>(null);
    const [isResultsVisible, setIsResultsVisible] = useState(false);
    const requestTypeRequiredFieldMessage = siteMessage("inquiryLineCard_requestTypeRequiredFieldMessage");
    const textFieldRef = useRef<HTMLInputElement | null>(null);
    const modalCloseHandler = () => setIsModalOpen(false);
    const modalRef = useRef<HTMLInputElement | null>(null);
    const handleMouseOverTextField = () => {
        setIsModalOpen(true);
    };
    const handleClickOutside = (event: any) => {
        // If the click is outside both the modal and the search input
        if (
            modalRef.current &&
            !modalRef.current.contains(event.target) &&
            textFieldRef.current &&
            !textFieldRef.current.contains(event.target)
        ) {
            // CloseModal
            setHover(false);
            // Call a function to close the modal, e.g., setModalOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Keep the modal open on modal hover
    const handleMouseOverModal = () => {
        setIsModalOpen(true);
    };

    // Close modal when leaving both the TextField and Modal
    const handleMouseOut = () => {
        setIsModalOpen(false);
    };

    const debouncedSearchProducts = debounce((query: string) => {
        if (query.length > 2) {
            searchProducts({ query });
        }
    }, 300);
    const onInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
        // setHover(false);
        debouncedSearchProducts(event.target.value);
    };
    useEffect(() => {
        // Whenever searchResults update, log the products
        if (searchResults?.searchResults) {
            searchResults?.searchResults.map(pro => {
                setFilterProduct(searchResults.searchResults || []);
            });
        } else {
            setFilterProduct([]);
        }
    }, [searchResults, inputValue]);

    const handleProductClick = (selectedProduct: any) => {
        setIsResultsVisible(false); // Hide results after selection
        history.push(selectedProduct.url);
    };
    const redirectMethod = (filProduct: any) => {
        history.push(filProduct.url);
    };

    const handleSearchIconClick = (selectedProduct: any) => {
        if (selectedProduct) {
            addSearchHistory(selectedProduct.trim());
            setSearchHistory(getSearchHistory()); // Update search history state
            setIsResultsVisible(false);
            history.push(`/Search?query=${selectedProduct}`); // Redirect to /Search?query=value
        }
    };
    // const searchHistoryItems = getSearchHistory();
    useEffect(() => {
        const searchHistoryItems = getSearchHistory(); // Re-fetch search history from localStorage
        setSearchHistory(searchHistoryItems);
    }, []);

    const clearLinkClickHandler = () => {
        clearSearchHistory();
        setSearchHistory([]);
        // Call to clear search history
    };
    const onMouseHover = () => {
        setHover(true);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            const query = (event.target as HTMLInputElement).value.trim(); // Get the value from the input field
            if (query && history) {
                // Ensure query and history are defined
                addSearchHistory(query.trim());
                setSearchHistory(getSearchHistory());
                setIsResultsVisible(false);
                history.push(`/Search?query=${query}`);
            }
        }
    };
    return (
        <StyledWrapper {...styles.mainContainer}>
            <StyledWrapper {...styles.headingContainer}>
                <Typography as="h2" {...styles.header}>
                    {siteMessage("Try Our Online Catalog")}
                </Typography>
                <Typography {...styles.textAreaStyles}>{siteMessage("Try Our Online Catalog Description")}</Typography>
            </StyledWrapper>
            <StyledWrapper
                css={css`
                    position: relative;
                `}
            >
                <StyledWrapper {...styles.searchDiv}>
                    <TextField
                        ref={textFieldRef}
                        {...styles.searchInput}
                        placeholder={translate("Search for anything")}
                        autoComplete="on"
                        clickableText={translate("submit search")}
                        data-test-selector="headerSearchInputTextField"
                        className="search-input"
                        //  onKeyPress={onKeyPress}
                        onKeyDown={handleKeyDown}
                        onChange={onInputChanged}
                        value={inputValue}
                        onFocus={() => {
                            setIsResultsVisible(true);
                            setHover(true); // Trigger your hover effect on focus
                        }}
                        iconClickableProps={{ onClick: () => handleSearchIconClick(inputValue) }}
                        onClick={onMouseHover}
                    />
                    {!hover && !inputValue && (
                        <LazyImage
                            src={fields.bannerImage}
                            altText={String(siteMessage("Try Our Online Catalog"))}
                            className="bannerImg"
                        ></LazyImage>
                    )}
                </StyledWrapper>

                {hover && inputValue.length === 0 && (
                    <StyledWrapper {...styles.productContainer}>
                        <StyledWrapper {...styles.searchModal}>
                            {/* Content that you want to show on hover */}

                            <StyledWrapper {...styles.mainWrapper}>
                                <StyledWrapper {...styles.rowWrapper}>
                                    <StyledWrapper {...styles.hoverMainWrapper} ref={modalRef}>
                                        <StyledWrapper {...styles.recentsearchWrapper}>
                                            <Typography className="searchHeading">
                                                {siteMessage("Search Results")}
                                            </Typography>

                                            <StyledWrapper {...styles.productInfoSearch}>
                                                <Typography className="searchDescription">
                                                    {siteMessage("searchDescription")}
                                                </Typography>
                                                <Typography className="categoryWrapper">
                                                    <Typography className="categoryHeading">
                                                        {siteMessage("Product Cateogories")}
                                                    </Typography>
                                                    <StyledWrapper className="categories">
                                                        {fields.tryourcatalogtypes.map((item: any, index) => (
                                                            <Link href={item.fields.categoryLink.value} key={index}>
                                                                {item.fields.categoryName}
                                                            </Link>
                                                        ))}
                                                    </StyledWrapper>
                                                </Typography>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                        <StyledWrapper className="recentSearch">
                                            <Typography className="recentSearchHeader">
                                                {siteMessage("Recent Search")}

                                                {searchHistory.length !== 0 && (
                                                    <Typography
                                                        as="a"
                                                        onClick={clearLinkClickHandler}
                                                        className="clearAll"
                                                    >
                                                        {siteMessage("Clear All ")}
                                                    </Typography>
                                                )}
                                            </Typography>
                                            <StyledWrapper className="searchList">
                                                {searchHistory.length > 0 ? (
                                                    searchHistory.map(searchHistoryItem => (
                                                        <StyledWrapper
                                                            key={searchHistoryItem.query}
                                                            {...styles.searchHistory}
                                                        >
                                                            <IconMemo {...styles.icon} />
                                                            <Link
                                                                onClick={() =>
                                                                    handleSearchIconClick(searchHistoryItem.query)
                                                                }
                                                            >
                                                                {searchHistoryItem.query}
                                                            </Link>
                                                        </StyledWrapper>
                                                    ))
                                                ) : (
                                                    <StyledWrapper {...styles.searchHistory}>
                                                        <Typography>{siteMessage("No Search Results")}</Typography>
                                                    </StyledWrapper>
                                                )}
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                )}
                {product.length > 0 && inputValue.length > 2 && (
                    <StyledWrapper {...styles.productContainer} ref={modalRef}>
                        <StyledWrapper {...styles.successModal}>
                            {/* Content that you want to show on hover */}

                            <StyledWrapper {...styles.mainWrapper}>
                                <StyledWrapper {...styles.rowWrapper}>
                                    <StyledWrapper {...styles.getProduct}>
                                        <Typography as="div"> {siteMessage("Products")}</Typography>
                                        <Link href={`/Search?query=${inputValue}`} className="getallProducts">
                                            {siteMessage("Get All Products ")}
                                            <ArrowRightIcon />
                                        </Link>
                                    </StyledWrapper>
                                    {product.map(filProduct => (
                                        <StyledWrapper key={filProduct.erpNumber} {...styles.productMainWrapper}>
                                            <StyledWrapper
                                                {...styles.productWrapper}
                                                onClick={() => handleProductClick(filProduct)}
                                            >
                                                <LazyImage
                                                    {...styles.productImage}
                                                    src={filProduct.image}
                                                    altText={filProduct.title}
                                                />
                                                <StyledWrapper {...styles.productInfo}>
                                                    <Typography className="brandName">
                                                        {filProduct.brandName}{" "}
                                                    </Typography>
                                                    <Typography className="brandNameTitle">
                                                        {filProduct.title}
                                                    </Typography>

                                                    <Typography className="mpn">
                                                        MPN:{" "}
                                                        <span>
                                                            {getBoldedText(
                                                                filProduct.manufacturerItemNumber,
                                                                inputValue,
                                                            )}
                                                        </span>
                                                    </Typography>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                            <Typography className="viewButton">
                                                <Button onClick={() => redirectMethod(filProduct)}>
                                                    {siteMessage("View Product")}
                                                </Button>
                                            </Typography>
                                        </StyledWrapper>
                                    ))}
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                )}
                {product.length === 0 && inputValue.length > 3 && (
                    <StyledWrapper {...styles.successModal}>
                        <StyledWrapper className="searchHeading">{siteMessage("No Results")}</StyledWrapper>
                        <Typography>
                            We couldn't found any product containing <b>{inputValue}</b>. Get in touch for help to
                            finding right product for your need,
                        </Typography>
                    </StyledWrapper>
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(CENTryOurNewCatalog)),
    definition: {
        group: "Contact Us",
        icon: "inputStyles-pipe",
        displayName: "Try Our New Catalog",
        fieldDefinitions: [
            {
                name: fields.tryourcatalogtypes,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.categoryName;
                },
                defaultValue: [],
                fieldType: "General",
                displayName: "Add  Categories",
                fieldDefinitions: [
                    {
                        name: fields.categoryName,
                        editorTemplate: "TextField",
                        displayName: "Category Name",
                        defaultValue: "",
                    },
                    {
                        name: "categoryLink",
                        displayName: "Redirection Link",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                    },
                ],
            },
            {
                name: fields.bannerImage,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Banner Image",
            },
        ],
    },
};

export default widgetModule;
